<ng-container *ngrxLet="{isMobile: isMobile$, downloads:downloads$}; let vm">

  <!-- 
  <ng-container *ngIf="vm.isMobile == false">
    <div id="spout-homepage-downloads">
      <div class="arrowpng" alt=""></div>

      <a
        [href]="vm.downloads.windows">
        WINDOWS
        <mat-icon>file_download</mat-icon>
      </a>
      <a
          [href]="vm.downloads.mac">
        MAC INTEL
        <mat-icon>file_download</mat-icon>
      </a>
      <a
          [href]="vm.downloads.macm1">
        MAC M1
        <mat-icon>file_download</mat-icon>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="vm.isMobile == true">
    <div id="spout-homepage-downloads" class="spt-download-spout-ios">
      <div class="accent download-trial">
        Download Spout for MOBILE
        <br />Coming Soon.
      </div>
    </div>
  </ng-container> -->
  <div id="spout-homepage-container">
    <div id="spout-homepage-top-copy">
      <h1>Make Music Together</h1>
      Connect with your band mates no matter where they are to make music in
      near real time. Spout is a collaboration platform for working musicians to
      make music with others, no matter where they are in the world.
    </div>
    <!-- <div class="spout-homepage-subscription-tier">
      <h1>PERSONAL PLAN</h1>
      Includes 1 GB Storage with all features enabled. <br />

      <button
        (click)="clickTier(2)"
        class="mat-focus-indicator mat-flat-button mat-button-base mat-primary">
        GET STARTED
      </button>

      <hr />
      $10.00 per Month or $72.00 per Year <br />
      $3.00 per Month for an additional 1 GB of storage.<br />
      Upload projects to the cloud & collaborate in real time. <br />
      Can invite collaborators and reviewers to your project. Can share, create,
      remix, and export tracks.
    </div> -->
    <div id="spout-homepage-more-info">
      <div style="width: 100%; text-align: center; margin-top: 0">
        <h1>Feature Overview</h1>
      </div>
      <div id="spout-homepage-features-content">
        <h2>Fast and flexible recording tool that includes</h2>
        <ul>
          <li>
            Record Tracks - get going quickly with our unique recording console
          </li>
          <li>Upload tracks - from any DAW to allow quick collaboration</li>
          <li>
            Render mix and share songs with friends, or upload to Facebook,
            Soundcloud etc
          </li>
          <li>
            Controls that help you design you tracks
            <ul>
              <li>Set and adjust recording latency</li>
              <li>Gain</li>
              <li>Select input</li>
            </ul>
          </li>
          <li>Automatic backup of songs</li>
          <li>Invite others to collaborate on you tracks</li>
          <li>Share tracks</li>
          <li>Real-time chat</li>
          <li>Add notes to tracks</li>
          <li>
            Marketing and distribution programs that allow you to make money on
            your music
          </li>
        </ul>
        <h2>Spout is ...</h2>
        <ul>
          <li>Platform agnostic (not tied to a specific software)</li>
          <li>Real time collaboration with anyone, anywhere</li>
          <li>
            Marketing and distribution tools (contact us at
            <a href="mailto:inquiries@spoutsoftware.com" target="_blank"
              >info@spoutsoftware.com</a
            >)
          </li>
        </ul>
      </div>
      <div id="spout-homepage-feature-image">
        <div id="section-img01"></div>
      </div>
      <div style="width: 100%; text-align: center">
        <h1>Spout is designed to meet your needs</h1>
      </div>
      <div class="spout-homepage-feature-role">
        <h2>Recording Studio</h2>
        <ul>
          <li>Record to the Cloud</li>
          <li>upload existing tracks</li>
          <li>Real time engagement</li>
        </ul>
      </div>
      <div class="spout-homepage-feature-role">
        <h2>Producers</h2>
        <ul>
          <li>Expand your client base</li>
          <li>Efficient workflow</li>
          <li>Improved speed of delivery</li>
        </ul>
      </div>
      <div class="spout-homepage-feature-role">
        <h2>Songwriters</h2>
        <ul>
          <li>Real time collaboration</li>
          <li>Improve the quality of your music</li>
          <li>Mix, share, distribute and sell your music</li>
        </ul>
      </div>
      <div class="spout-homepage-feature-role">
        <h2>Bands</h2>
        <ul>
          <li>Get new ideas going quickly</li>
          <li>Mix and share with the industry</li>
          <li>Have a hit - we can help with marketing and distribution</li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>
